import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import AddToWalletButton from './AddToWalletButton';
import { getAccountDetailsContent } from '../../store/contentSlice';
import { setImagePath, detectDeviceType } from '../../utils/helpers';
import {
  WALLET_TYPE_APPLE,
  WALLET_TYPE_GOOGLE,
  APPLE_WALLET_BUTTON_ID,
  GOOGLE_WALLET_BUTTON_ID,
} from './addToWalletConstants';
import { CLIENT_ID_PAYSOL } from '../../utils/constants/genericConstants';

const AddToWallet = (props: any): ReactElement => {
  const {
    addToWallet: {
      appleWallet: { appleWalletMessage },
    },
  }: any = useSelector(getAccountDetailsContent);
  const {
    isAccordionCollapsed,
    index,
    cardType,
    displayName,
    features,
    clientId,
    portfolio,
    productType,
  } = props;
  const { accessToAppleWallet, accessToGoogleWallet } = features;
  const updatedClientId = clientId === CLIENT_ID_PAYSOL ? portfolio : clientId;

  return (
    <div className="add-to-wallet-wrapper">
      <span className="add-to-wallet-instruction-text">
        {appleWalletMessage}
      </span>
      <div
        className="add-to-wallet-button-wrapper"
        data-testid="logo-account-details-add-to-wallet"
      >
        {accessToAppleWallet && (
          <AddToWalletButton
            buttonImgSrc={setImagePath('add-to-apple-wallet')}
            dataTestId="addtoWallet-ios"
            ariaLabel="add to apple wallet"
            altTag="apple wallet button image"
            buttonId={`${APPLE_WALLET_BUTTON_ID}_${index}`}
            tabIndex={isAccordionCollapsed ? -1 : 0}
            walletType={WALLET_TYPE_APPLE}
            cardType={cardType}
            dataType={detectDeviceType}
            dataReason={`${displayName}:appleWallet`}
            clientId={updatedClientId}
            productType={productType}
          />
        )}
        {accessToGoogleWallet && (
          <AddToWalletButton
            buttonImgSrc={setImagePath('add-to-google-wallet')}
            dataTestId="addtoWallet-AndroidOS"
            ariaLabel="add to google wallet"
            altTag="google wallet button image"
            buttonId={GOOGLE_WALLET_BUTTON_ID}
            tabIndex={isAccordionCollapsed ? -1 : 0}
            walletType={WALLET_TYPE_GOOGLE}
            cardType={cardType}
            dataType={detectDeviceType}
            dataReason={`${displayName}:googleWallet`}
            clientId={updatedClientId}
            productType={productType}
          />
        )}
      </div>
    </div>
  );
};

export default AddToWallet;
